module.exports = __webpack_public_path__ + "static/media/hamza.ecb6aa44.png";